import diacritics from "diacritics";
import template from "./section-gallery-modal.html";

const SectionGalleryModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },

  template,

  controller: class SectionGalleryModalController {
    /* @ngInject */
    constructor(
      $rootScope,
      $scope,
      $filter,
      QuoteSectionTemplate,
      Notification,
      ModalsManager,
      SweetAlertService
    ) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$filter = $filter;
      this.QuoteSectionTemplate = QuoteSectionTemplate;
      this.NotificationService = Notification;
      this.ModalsManager = ModalsManager;
      this.SweetAlertService = SweetAlertService;
    }

    async $onInit() {
      this.loading = true;
      this.sectionsOnGallery = [];
      this.sectionsOnGallery = await this.QuoteSectionTemplate.query();
      this.sectionsOnGallerySearch = angular.copy(this.sectionsOnGallery);
      this.currentFilter = "createdAt";
      this.reverse = false;
      this.searchName = null;
      this.$rootScope.$applyAsync();
      this.loading = false;

      this.$scope.$watch(
        () => this.searchName,
        async (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            if (!newVal) {
              this.currentFilter = "createdAt";
              this.reverse = false;
            }
            this.sectionsOnGallerySearch = angular.copy(this.sectionsOnGallery);
            this.sectionsOnGallerySearch = this.sectionsOnGallerySearch.filter(
              (section) => {
                return section.nameCanonical.includes(
                  diacritics.remove(newVal).toLowerCase()
                );
              }
            );
          }
        }
      );
    }

    selectSection(section) {
      delete section._id;
      return this.close({ $value: section });
    }

    async editSectionName(section) {
      const quoteSectionName =
        await this.ModalsManager.openQuoteSectionNameModal(section.name);
      if (!quoteSectionName) return;

      section.name = quoteSectionName;
      if (!(await section.update())) return;
      this.$rootScope.$applyAsync();

      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.sectionSaved"
        ),
      });
    }

    async deleteSection(section) {
      if (await this.SweetAlertService.wantRemoveSection()) {
        this.loading = true;
        const deletedSectionId = section._id;
        await section.delete();
        this.sectionsOnGallery = this.sectionsOnGallery.filter(
          (sectionOnArray) => sectionOnArray._id !== deletedSectionId
        );
        this.sectionsOnGallerySearch = angular.copy(this.sectionsOnGallery);
        this.$rootScope.$applyAsync();
        this.loading = false;
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")(
            "notificationService.message.sectionDeleted"
          ),
        });
      }
    }

    sortBy(currentFilter) {
      this.reverse =
        this.currentFilter === currentFilter ? !this.reverse : false;
      this.currentFilter = currentFilter;
    }

    existSections() {
      return this.sectionsOnGallery.length > 0;
    }

    close() {
      return this.dismiss({ $value: "cancel" });
    }
  },
};

export default SectionGalleryModalComponent;
